<template>
<div>
    <div v-if="initilizingCart" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <div v-if="submitted" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <!-- Cart Error Display -->
    <div v-if="cartError" class="error_popup popup-desktop" style="display:block;">
        <div class="error_box error-pop-desk">
            <div class="text-block-1101">Cart Error</div>
            <div class="text-block-1102">{{ message }}</div>
        </div>
    </div>

    <!-- Payment Error Toast -->
    <div v-if="paymentError" class="error-popup">
        <span>{{ errorMessage }}</span>
        <button class="error-popup-close" @click="paymentError = false">&times;</button>
    </div>

    <!-- Address Error Display -->
    <div class="checkout-popup-div" v-if="addressError" style="display:block;">
        <div class="popup-box">
            <div class="text-block-956">Address Error</div>
            <div class="text-block-957">Our shipping partners, FedEx and UPS, do not deliver to PO Box addresses.</div>
            <div class="next-div">
                <a href="#" @click.prevent="addressError=false;" class="link-53">Change Address <span class="text-span-211">-&gt;</span></a>
            </div>
            <a data-w-id="7a9ce3e2-0512-f29f-99f7-5b31ca5cc875" @click.prevent="addressError=false;" href="#" class="close-link w-inline-block"><img src="@/assets/images/icon_Close.svg" loading="lazy" alt="Close"></a>
        </div>
    </div>

    <section class="section_checkout-nav">
        <div class="checkout-top-nav-elements">
            <a href="#" class="logo-link w-inline-block">
                <img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="NewSelf" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-414">
            </a>
            <div class="form-nav-div-2">
                <router-link to="/weight-loss-plan" class="back-link-2 w-inline-block">
                    <div class="text-block-817">&lt;-</div>
                </router-link>
                <div class="progress-div-2">
                    <div>
                        <div class="step-text">Checkout</div>
                    </div>
                    <div class="progress-precent-div">

                    </div>
                </div>
            </div>
            <div class="checkout-help-wrap">
                <!--<div class="help-label">Help</div>
                <a href="#" @click.prevent="showChatWindow" class="link-block-62 w-inline-block">
                    <div class="checkout-help-div">
                        <div class="help-text">?</div>
                    </div>
                </a>-->
            </div>
        </div>
    </section>

    <section v-if="!initilizingCart" class="section_checkout">
        <div class="checkout-left-div">
            <h1 class="checkout-header">Review & Checkout</h1>
            <div class="bullets-div-2 hidemobile">
                <div class="bullets-flex-2">
                    <div class="bullet-point-3"><img loading="lazy" src="@/assets/images/icon_Dollar_blk.svg" alt="Same price" class="image-632 _1">
                        <div class="text-block-1562"><strong>All Dosages Same price</strong></div>
                    </div>
                    <div class="bullet-point-3"><img loading="lazy" src="@/assets/images/icon_Pricetrophy_blk.svg" alt="Everything included" class="image-632">
                        <div class="text-block-1562"><strong>Everything Included</strong></div>
                    </div>
                </div>
                <div class="bullets-flex-2">
                    <div class="bullet-point-3"><img loading="lazy" src="@/assets/images/icon_PM_No-Price-Increase_blk.webp" alt="No price increases" class="image-632">
                        <div class="text-block-1562"><strong>No Price Increases</strong></div>
                    </div>
                    <div class="bullet-point-3"><img loading="lazy" src="@/assets/images/icon_savings_blk.svg" alt="No membership fees" class="image-632">
                        <div class="text-block-1562"><strong>No Membership Fees</strong></div>
                    </div>
                </div>
            </div>

            <!-- Payment Plan Selection -->
            <div class="plan-selection-div">
                <div class="form-block-21 w-form">
                    <form id="email-form-8" name="email-form-8" data-name="Email Form 8" method="get">
                        <label for="payment-plan" class="field-label-5">Choose your payment plan:</label>

                        <!-- Monthly Plan -->
                        <label class="plan-radio" :class="{ selected: paymentInfo.payment_terms === 1 }" @click="changePaymentTerms(1)">
                            <input type="radio" v-model="paymentInfo.payment_terms" :value="1" name="payment-plan" class="w-form-formradioinput radio-button w-radio-input">
                            <span class="radio-button-label-5 w-form-label">
                                <span class="text-span-332">Pay Monthly</span>
                            </span>
                            <div class="div-block-2096">
                                <div>
                                    <span class="text-span-333">${{ getFirstMonthDollars }}</span>
                                    <span><sup class="superscript-2">{{ getFirstMonthCents }}</sup></span>
                                </div>
                                <div class="text-block-1439">A Month</div>
                            </div>
                            <div class="text-block-1437">3 Month Supply paid monthly<br class="hide-desk"/> with no interest or credit check.</div>
                        </label>

                        <!-- Quarterly Plan -->
                        <label class="plan-radio" :class="{ selected: paymentInfo.payment_terms === 3 }" @click="changePaymentTerms(3)">
                            <input type="radio" v-model="paymentInfo.payment_terms" :value="3" name="payment-plan" class="w-form-formradioinput radio-button w-radio-input">
                            <span class="radio-button-label-5 w-form-label">
                                <span class="text-span-332">Pay For 3 Months</span>
                            </span>
                            <div class="div-block-2096">
                                <div>
                                    <span class="text-span-333">${{ getQuarterlyDollars }}.</span>
                                    <span><sup class="superscript-2">{{ getQuarterlyCents }}</sup></span>
                                </div>
                                <div class="text-block-1439">A Month</div>
                            </div>
                            <div class="text-block-1437">
                                ${{ getTotalPrice(3) }} Total for 3 Months<br>
                                <span class="text-span-334">${{ getSavingsText(3) }}</span>
                            </div>
                        </label>

                        <!-- 6-Month Plan -->
                        <label class="plan-radio" :class="{ selected: paymentInfo.payment_terms === 6 }" @click="changePaymentTerms(6)">
                            <span class="plan-badge plan-badge--popular">Popular</span>
                            <input type="radio" v-model="paymentInfo.payment_terms" :value="6" name="payment-plan" class="w-form-formradioinput radio-button w-radio-input">
                            <span class="radio-button-label-5 w-form-label">
                                <span class="text-span-332">Pay For 6 Months</span>
                            </span>
                            <div class="text-block-1437">
                                ${{ getTotalPrice(6) }} Total 6 Months<br>
                                <span class="text-span-334">${{ getSavingsText(6) }}</span>
                            </div>
                            <div class="div-block-2096">
                                <div>
                                    <span class="text-span-333">${{ getSixMonthDollars }}.</span>
                                    <span><sup class="superscript-2">{{ getSixMonthCents }}</sup></span>
                                </div>
                                <div class="text-block-1439">A Month</div>
                            </div>
                        </label>

                        <!-- Annual Plan -->
                        <label class="plan-radio" :class="{ selected: paymentInfo.payment_terms === 12 }" @click="changePaymentTerms(12)">
                            <span class="plan-badge plan-badge--recommended">Recommended</span>
                            <input type="radio" v-model="paymentInfo.payment_terms" :value="12" name="payment-plan" class="w-form-formradioinput radio-button w-radio-input">
                            <span class="radio-button-label-5 w-form-label">
                                <span class="text-span-332">Pay For 12 Months</span>
                            </span>
                            <div class="text-block-1437">
                                ${{ getTotalPrice(12) }} Total 12 Months<br>
                                <span class="text-span-334">${{ getSavingsText(12) }}</span>
                            </div>
                            <div class="div-block-2096">
                                <div>
                                    <span class="text-span-333">${{ getAnnualDollars }}.</span>
                                    <span><sup class="superscript-2">{{ getAnnualCents }}</sup></span>
                                </div>
                                <div class="text-block-1439">A Month</div>
                                <SummerSaleBadge />
                            </div>
                        </label>
                    </form>
                </div>
            </div>

            <!-- Mobile Order Summary -->
            <div class="checkout-summary-div mobile">
                <div class="summary-top">
                    <h2 class="checkout-form-header">Order Summary</h2>

                </div>
                <div class="dropdown-sum update" v-if="getcartItems">
                    <div class="order-summary-div">
                        <div class="order-dropdown">
                            <div class="dropdown-sum-toggle" >
                                <!--<div class="open-drop-text" :class="{ 'w--open': isOpenToggle }" @click="isOpenToggle = !isOpenToggle">
                                    <div class="text-block-336 step-1 update">Tap to access full order details</div>
                                    <div class="icon-19 w-icon-dropdown-toggle"></div>
                                </div>-->
                                <div class="order-box-div">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div">
                                                    <img :src="getImage" loading="lazy" :alt="getcartItems.name" style="border-radius: 9px;">
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{ getcartItems.name }}</div>
                                                <div class="text-block-850 _1" v-if="getcartItems.name==='Semaglutide'">Compounded w/ B12</div>
                                                <div class="text-block-850 _1" v-else>Compounded w/ B6</div>
                                                <div class="text-block-850 _2" style="font-size:12px">{{ getSupplyDuration }}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">
                                            ${{ getOrderSummaryPrice }}
                                        </div>
                                        <div class="div-block-1778">
                                            <div v-if="paymentInfo.payment_terms === 1" class="item-price-text blk">${{ getOrderSummaryPrice }}</div>
                                            <div v-if="paymentInfo.payment_terms === 1" class="text-block-849">Then ${{ getRegularMonthlyPrice() }} monthly</div>
                                            <div v-if="paymentInfo.payment_terms > 1" class="item-price-text blk">${{ getTotalPrice(paymentInfo.payment_terms) }}</div>
                                            <div v-if="paymentInfo.payment_terms > 1" class="text-block-849">Total for {{ paymentInfo.payment_terms }} months</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- The free NAD+ line from the lander's offer link. Under the main
                                     product, so it shows with the details closed. -->
                                <div v-if="offerNadLine" class="order-box-div">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976 addons">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div addon-image">
                                                    <img :src="nadFreeImage" loading="lazy" alt="" class="offer-image">
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{ offerNadName }}</div>
                                                <div class="text-block-850">{{ offerNadLabel }}</div>
                                                <div v-if="offerNadNote" class="free-nad-note">{{ offerNadNote }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text blk">${{ offerNadLine.price.toFixed(2) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Add-on Products for Mobile -->

                            <!-- Dropdown content for included services -->
                            <nav class="dropdown-summary w-dropdown-list" :class="{ 'w--open': isOpenToggle }">
                                <div v-if="getAddonProducts.length > 0" class="order-box-div" style="border-top: 1px solid #eee; margin-top: 10px; padding-top: 10px;">
                                    <div class="div-block-960 new" v-for="addon in getAddonProducts" :key="addon.id" style="margin-bottom: 8px;">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div addon-image" style="background-color: #f0f8ff;">
                                                    <img :src="addon.image" loading="lazy" :alt="addon.name">
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{ addon.name }}</div>
                                                <div class="text-block-850">{{ addon.subheader || 'Add-on Product' }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text blk">${{ (addon.price * addon.quantity).toFixed(2) }}</div>
                                            <div class="text-block-849" style="font-size: 11px;">Billed every 3 months</div>
                                        </div>
                                    </div>
                                    <a href="#" tooltip="Remove Item" @click.prevent="removeItem(addon.id)" class="link-block-66 w-inline-block">
                                        <img src="@/assets/images/icon_trash.svg" loading="lazy" alt="Remove item">
                                    </a>
                                </div>
                                <div class="order-box-div">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976 addons">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div icon">
                                                    <img src="@/assets/images/HIW_call.webp" loading="lazy" alt="Physician consultation" class="icon-img _1">
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2"><strong>Physician Consult</strong></div>
                                                <div class="text-block-850">Board-certified experts</div>
                                            </div>
                                        </div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text free">Included</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order-box-div">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976 addons">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div icon">
                                                    <img src="@/assets/images/checkout_chart.webp" loading="lazy" alt="Personalized plan" class="icon-img _2">
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2"><strong>Personalized Plan</strong></div>
                                                <div class="text-block-850">AI metabolic weight loss system</div>
                                            </div>
                                        </div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text free">Included</div>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>

                <!-- Mobile Summary Totals -->
                <div class="checkout-summary-entry new" v-if="!isOpenToggle && getAddonProducts.length > 0">
                    <div class="text-block-821" @click.prevent="isOpenToggle = !isOpenToggle">Additional Products <span style="color: blue; font-weight: 900;">+</span></div>
                    <div class="text-block-822">$19.97</div>
                </div>

                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Shipping</div>
                    <div class="text-block-822">FREE</div>
                </div>
                <div v-if="couponApplied && paymentInfo.discount > 0" class="checkout-summary-entry new">
                    <div class="text-block-821">Discount</div>
                    <div class="text-block-822"><img src="@/assets/images/icon_tag.svg" loading="lazy" alt="Discount" class="image-490"> -${{ paymentInfo.discount }}</div>
                </div>
                <div class="total-amount">
                    <div class="total-price-text">Total</div>
                    <div class="total-price-text">${{ (couponApplied ? (displayTotal - paymentInfo.discount) : displayTotal).toFixed(2) }}</div>
                </div>
                <div class="summary-sub" v-if="paymentInfo.payment_terms === 1">
                    You'll be charged ${{ getRegularMonthlyPrice() }} Month 2 onwards.
                </div>

                <!-- Mobile Promo Code -->
                <div class="promo-div-2 new">
                    <div class="form-block-11 checkout w-form">
                        <form>
                            <input class="promo-text-field w-input" v-model="couponInput" maxlength="256" name="Promo-Code-2" placeholder="Promo Code" type="text" id="Promo-Code-2">
                        </form>
                    </div>
                    <div class="promo-button-div">
                        <a href="#" @click.prevent="handleCouponSubmit" class="checkout-button-3 promo new w-button">SUBMIT</a>
                    </div>
                </div>
                <div v-if="couponError" class="w-form-fail" style="display:block;">
                    <div>Invalid promo code. Please try again.</div>
                </div>
                <div v-if="couponApplied" class="w-form-done">
                    <div>Promo code applied successfully!</div>
                </div>
            </div>

            <!-- Payment Details Section -->
            <div class="card-div">
                <div class="shipping-form-div">
                    <h2 class="checkout-form-header form bold">Enter Payment Details</h2>
                </div>
                <div class="card-input-form w-form">
                    <form @submit.prevent="getStripeToken" class="form-20">
                        <div class="card-fields-div">
                            <!-- Express Checkout (Apple Pay / Google Pay / Klarna) -->
                            <div class="express-checkout-section" v-if="paymentInfo.payment_terms !== 1">
                                <div class="express-checkout-box" :class="{ 'single-option': !canMakeExpressCheckout }">
                                    <express-checkout-button
                                        :amount="walletSheetAmountInCents"
                                        @token="handleExpressPayment"
                                        @can-make-payment="canMakeExpressCheckout = $event"
                                    />
                                    <button type="button" class="klarna-btn" :disabled="submitted" @click="payWithKlarna">
                                        <span class="klarna-btn-text">Buy now, pay later with</span>
                                        <img class="klarna-logo" src="@/assets/images/Klarna.png" alt="Klarna" />
                                    </button>
                                </div>
                                <div class="pe-divider">
                                    <div class="pe-divider-line"></div>
                                    <span>OR</span>
                                    <div class="pe-divider-line"></div>
                                </div>
                            </div>

                            <!--<div class="div-block-2255">
                                <div class="form-field-label">Credit Card Number</div>
                                <div class="cards-div-copy"><img width="Auto" loading="lazy" alt="Visa" src="@/assets/images/card-visa.png" class="image-416"><img width="35" loading="lazy" alt="Mastercard" src="@/assets/images/card-mastercard.png" class="image-416"><img width="35" loading="lazy" alt="American Express" src="@/assets/images/card-amex.png" class="image-416"><img width="35" loading="lazy" alt="Discover" src="@/assets/images/card-discover.png" class="image-416"></div>
                            </div>-->
                            <stripe-payment-element
                                ref="stripePayment"
                                :base-url="baseUrl"
                                :user-id="user?.id"
                                :user-name="`${user?.first_name || ''} ${user?.last_name || ''}`.trim()"
                                :user-email="user?.email"
                                :hide-address-fields="true"
                                :billing-address="customerInfo"
                                @ready="hasCardInput = $event"
                                @error="handlePaymentError"
                                @token="handlePaymentToken"
                            />

                            <!-- Shipping Address -->
                            <div class="address-section">
                                <label class="pe-label-7x" style="margin-top: 20px; display: block;">Shipping Address</label>
                                <div :class="{ 'address-highlight': addressBlink }">
                                    <google-places-autocomplete-new :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                                </div>
                            </div>

                            <button type="submit" :disabled="submitted" class="checkout-button-3 desktop new w-button checkout-button-3-checkout" style="height:55px;">
                                {{ submitted ? 'Processing...' : 'Pay Now' }}
                            </button>

                            <p class="paragraph-185">
                                By clicking "Pay Now" you agree to enroll in a {{ paymentInfo.payment_terms }}-month program{{ paymentInfo.payment_terms > 1 ? ' billed upfront' : ' billed monthly' }}, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the
                                <a href="https://newself.com/returns-and-refund" target="_blank">Refund Policy</a>,
                                <a href="https://newself.com/terms-of-use" target="_blank">Terms and Conditions</a>,
                                <a href="https://newself.com/terms-of-use" target="_blank">Terms of Use</a>,
                                <a href="https://newself.com/privacy-policy" target="_blank">Privacy Policy</a>, and
                                <a href="/documents/Telehealth_Consent_Form.pdf" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                            </p>
                        </div>
                        <div class="w-form-fail" style="display: block;" v-if="paymentError">
                            <p>{{ errorMessage }}</p>
                        </div>
                        <!-- Google Pay / Apple Pay (if supported) -->

                    </form>
                </div>
            </div>

            <!-- Security Features -->
            <div class="desktop-pay-button-div">
                <div class="inclusions-div">
                    <div class="inclusions">
                        <div class="text-block-1435">Free and discreet deliveries</div>
                        <div class="inclusion-icon-div _1">
                            <img src="@/assets/images/icon_package-white.svg" loading="lazy" alt="Free shipping">
                        </div>
                    </div>
                    <div class="inclusions">
                        <div class="text-block-1435">Backed by US-licensed physicians</div>
                        <div class="inclusion-icon-div _2">
                            <img src="@/assets/images/icon_doc_1.svg" loading="lazy" alt="Licensed physician">
                        </div>
                    </div>
                    <div class="inclusions">
                        <div class="text-block-1435">256-BIT TLS payment security</div>
                        <div class="inclusion-icon-div _3">
                            <img src="@/assets/images/icon_lock.svg" loading="lazy" alt="Secure payment">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Desktop Order Summary -->
        <div class="checkout-right-div">
            <div class="mobile-pay-button-div">
                <div class="inclusions-div">
                    <div class="inclusions">
                        <div class="text-block-1435">Free and discreet deliveries</div>
                        <div class="inclusion-icon-div _1">
                            <img src="@/assets/images/icon_package-white.svg" loading="lazy" alt="Free shipping">
                        </div>
                    </div>
                    <div class="inclusions">
                        <div class="text-block-1435">Backed by US-licensed physicians</div>
                        <div class="inclusion-icon-div _2">
                            <img src="@/assets/images/icon_doc_1.svg" loading="lazy" alt="Licensed physician">
                        </div>
                    </div>
                    <div class="inclusions">
                        <div class="text-block-1435">256-BIT TLS payment security</div>
                        <div class="inclusion-icon-div _3">
                            <img src="@/assets/images/icon_lock.svg" loading="lazy" alt="Secure payment">
                        </div>
                    </div>
                </div>
            </div>

            <div class="checkout-summary-div desktop new" v-if="getcartItems">
                <div class="summary-top desk">
                    <h2 class="checkout-form-header box" style="border: none;">Order summary</h2>
                </div>

                <!-- Main Product -->
                <div class="order-box-div">
                    <div class="div-block-960 new">
                        <div class="div-block-976">
                            <div class="div-block-974">
                                <div class="checkout-product-div">
                                    <img :src="getImage" loading="lazy" :alt="getcartItems.name">
                                </div>
                            </div>
                            <div>
                                <div class="product-name-2">{{ getcartItems.name }}</div>
                                <div class="text-block-850 _1">Compounded w/ B6 (Pyridoxine)</div>
                                <div class="text-block-850 _2">{{ getSupplyDuration }}</div>
                            </div>
                        </div>
                        <div class="text-block-141 new">
                            ${{ getOrderSummaryPrice }}
                        </div>
                        <div class="div-block-1778">
                            <div v-if="paymentInfo.payment_terms === 1" class="item-price-text blk">${{ getOrderSummaryPrice }}</div>
                            <div v-if="paymentInfo.payment_terms === 1" class="text-block-849">Then ${{ getRegularMonthlyPrice() }} monthly</div>
                            <div v-if="paymentInfo.payment_terms > 1" class="item-price-text blk">${{ getTotalPrice(paymentInfo.payment_terms) }}</div>
                            <div v-if="paymentInfo.payment_terms > 1" class="text-block-849">Total for {{ paymentInfo.payment_terms }} months</div>
                        </div>
                    </div>

                </div>
                <!-- The free NAD+ line from the lander's offer link -->
                <div v-if="offerNadLine" class="order-box-div">
                    <div class="div-block-960 new">
                        <div class="div-block-976 addons">
                            <div class="div-block-974">
                                <div class="checkout-product-div addon-image">
                                    <img :src="nadFreeImage" loading="lazy" alt="" class="offer-image">
                                </div>
                            </div>
                            <div>
                                <div class="product-name-2">{{ offerNadName }}</div>
                                <div class="text-block-850">{{ offerNadLabel }}</div>
                                <div v-if="offerNadNote" class="free-nad-note">{{ offerNadNote }}</div>
                            </div>
                        </div>
                        <div class="div-block-1778">
                            <div class="item-price-text addon-price">${{ offerNadLine.price.toFixed(2) }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="getAddonProducts.length > 0">
                    <div class="order-box-div" v-for="addon in getAddonProducts" :key="addon.id">
                        <div class="div-block-960 new">
                            <div class="div-block-976 addons">
                                <div class="div-block-974">
                                    <div class="checkout-product-div addon-image">
                                        <img :src="addon.image" loading="lazy" :alt="addon.name">
                                    </div>
                                </div>
                                <div>
                                    <div class="product-name-2">{{ addon.name }}</div>
                                    <div class="text-block-850">{{ addon.subheader || 'Add-on Product' }}</div>
                                </div>
                            </div>
                            <div class="div-block-1778">
                                <div class="item-price-text addon-price">${{ (addon.price * addon.quantity).toFixed(2) }}</div>
                                <div class="text-block-849">Billed every 3 months</div>
                            </div>
                        </div>
                        <a href="#" tooltip="Remove Item" @click.prevent="removeItem(addon.id)" class="link-block-66 w-inline-block">
                            <img src="@/assets/images/icon_trash.svg" loading="lazy" alt="Remove item">
                        </a>
                    </div>
                </div>
                <!-- Included Services -->
                <div class="order-box-div">
                    <div class="div-block-960 new">
                        <div class="div-block-976 addons">
                            <div class="div-block-974">
                                <div class="checkout-product-div icon">
                                    <img src="@/assets/images/HIW_call.webp" loading="lazy" alt="Physician consultation" class="icon-img _1">
                                </div>
                            </div>
                            <div>
                                <div class="product-name-2"><strong>Physician Consultation</strong></div>
                                <div class="text-block-850">Consult with Board-certified experts</div>
                            </div>
                        </div>
                        <div class="div-block-1778">
                            <div class="item-price-text free">Included</div>
                        </div>
                    </div>
                </div>

                <div class="order-box-div">
                    <div class="div-block-960 new">
                        <div class="div-block-976 addons">
                            <div class="div-block-974">
                                <div class="checkout-product-div icon">
                                    <img src="@/assets/images/checkout_chart.webp" loading="lazy" alt="Personalized plan" class="icon-img _2">
                                </div>
                            </div>
                            <div>
                                <div class="product-name-2"><strong>Personalized Weight Loss Plan</strong></div>
                                <div class="text-block-850">Tailored recommendations</div>
                            </div>
                        </div>
                        <div class="div-block-1778">
                            <div class="item-price-text free">Included</div>
                        </div>
                    </div>
                </div>

                <!-- Disclaimer -->
                <div class="text-block-1434">
                    *The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.
                </div>

                <!-- Desktop Promo Code -->
                <div class="promo-div-2 new">
                    <div class="form-block-11 checkout w-form">
                        <form>
                            <input class="promo-text-field w-input" v-model="couponInput" maxlength="256" name="Promo-Code-2" placeholder="Promo Code" type="text" id="Promo-Code-2">
                        </form>

                        <div v-if="couponApplied" class="w-form-done">
                            <div>Promo code applied successfully!</div>
                        </div>
                    </div>
                    <div class="promo-button-div">
                        <a href="#" @click.prevent="handleCouponSubmit" class="checkout-button-3 promo new w-button">SUBMIT</a>
                    </div>
                </div>
                <div v-if="couponError" class="w-form-fail" style="display:block;">
                    <div>Invalid promo code. Please try again.</div>
                </div>
                <!-- Desktop Summary Totals -->
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Shipping</div>
                    <div class="text-block-822">FREE</div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Subtotal</div>
                    <div class="text-block-822">${{ getTotalOrderAmount() }}</div>
                </div>
                <div v-if="couponApplied && paymentInfo.discount > 0" class="checkout-summary-entry new">
                    <div class="text-block-821">Discount</div>
                    <div class="text-block-822"><img src="@/assets/images/icon_tag.svg" loading="lazy" alt="Discount" class="image-490">-${{ paymentInfo.discount }}</div>
                </div>
                <div class="total-amount">
                    <div class="total-price-text">Total</div>
                    <div class="total-price-text">${{ (couponApplied ? (displayTotal - paymentInfo.discount) : displayTotal).toFixed(2) }}</div>
                </div>
                <div class="summary-sub" v-if="paymentInfo.payment_terms === 1">
                    You'll be charged ${{ getRegularMonthlyPrice() }} Month 2 onwards.
                </div>
            </div>
        </div>
    </section>

    <!-- Hidden form for trusted form (if needed) -->
    <input type="hidden" ref="trustedFormUrl" value="">

    <!-- Priority Physician Review — offered once the order is captured, never before -->
    <fast-track-upsell-modal
        v-if="fastTrackOffer"
        :addon="fastTrackAddon"
        :payment-method="fastTrackOffer.paymentMethod"
        :context="fastTrackOffer"
        @shown="onFastTrackShown"
        @purchased="onFastTrackPurchased"
        @done="onFastTrackDone"
    />
</div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js"
let stripe = null;

import detectMobile from '@/utils/MobileDetection.js'
import GooglePlacesAutocompleteNew from '../common/GooglePlacesAutocomplete_new.vue'
import StripePaymentElement from '../common/StripePaymentElement.vue'
import ExpressCheckoutButton from '../common/ExpressCheckoutButton.vue'
import fastTrackUpsell from '@/mixins/fastTrackUpsell.js'
import freeNadLifeOffer from '@/mixins/freeNadLifeOffer.js'
import { stashKlarnaPurchase } from '@/utils/klarnaPurchaseTracking.js'
import { offerQuery } from '@/utils/freeNadLifeOffer.js'
import {
    mapActions,
    mapGetters
} from 'vuex';

export default {
    name: 'CheckoutComponent',
    mixins: [fastTrackUpsell, freeNadLifeOffer],
    fastTrackFunnelStep: 18,
    fastTrackForm: "pre_qualify",
    components: {
        GooglePlacesAutocompleteNew,
        StripePaymentElement,
        ExpressCheckoutButton
    },
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            paymentAttempts: 0,
            maxPaymentAttempts: 3,
            appName: process.env.VUE_APP_COMPANY,
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            payment_open: 0,
            paymentError: false,
            errorMessage: '',
            initilizingCart: true,
            ip_address:'',
            cartError: false,
            isApplePaySupported: false,
            isGooglePaySupported: false,
            couponValid: true,
            couponError: false,
            couponApplied: false,
            submitted: false,
            correlationId: null,
            addressError: false,
            trustUrl: '',
            couponInput: '',
            message: '',
            offer: '',
            isOpenToggle: true,
            hasCardInput: false,
            addressBlink: false,
            canMakeExpressCheckout: false,

            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            paymentInfo: {
                payment_terms: 6,
                user_id: '',
                cardToken: '',
                cardBrand: '',
                amount: 499,
                discount: 0,
                medication: '',
                couponCode: '',
                drug_mode: '',
                couponId: null,
                paymentMethod: null,
                cartItems: [],
                cardDetails: [],
                planId: '',
                // Card info from Stripe
                cardBin: '',
                cardLast4: '',
            },
            pricingConfig: JSON.parse(process.env.VUE_APP_PRICING || '{"semaglutide":{"monthly":{"first":194.97,"regular":194.97},"terms":{"3":449.91,"6":767.82,"12":1199.64}},"tirzepatide":{"monthly":{"first":274.97,"regular":274.97},"terms":{"3":644.91,"6":1129.08,"12":2099.64}}}'),
            // Live PROMO plan prices/ids, keyed by term. Empty until loadPlans
            // resolves; on fetch failure it stays empty so pricing falls back to pricingConfig
            // and planId falls back to the store offer. Pulling live prices means backend price
            // changes show here automatically — no manual VUE_APP_PRICING edits.
            apiPlans: {},
            // The term add_to_cart last reported. A plan tile is a <label> wrapping its
            // radio, so one shopper click reaches changePaymentTerms twice and would
            // otherwise send the same event twice, one millisecond apart.
            lastTrackedTerm: null,
            paymentTermLabels: {
                1: {
                    planName: "Monthly Plan",
                    duration: "monthly",
                    billingFrequency: "monthly",
                    billingLabel: "Billed Monthly",
                    supplyDuration: "Monthly"
                },
                3: {
                    planName: "Quarterly Plan",
                    duration: "3-month",
                    billingFrequency: "quarterly",
                    billingLabel: "Billed Quarterly",
                    supplyDuration: "3 Month"
                },
                6: {
                    planName: "Half yearly Plan",
                    duration: "6-month",
                    billingFrequency: "every 6 months",
                    billingLabel: "Billed Every 6 Months",
                    supplyDuration: "6 Month"
                },
                12: {
                    planName: "yearly Plan",
                    duration: "12-month",
                    billingFrequency: "annually",
                    billingLabel: "Billed Annually",
                    supplyDuration: "12 Month"
                }
            }
        }
    },

    async mounted() {
        await this.checkAuthAndInitialize();
        await this.getIpAddress();

        window.addEventListener('pageshow', this.handlePageShow);
    },
    beforeDestroy() {
        window.removeEventListener('pageshow', this.handlePageShow);
    },
    created() {

    },
    watch: {
        paymentError(val) {
            if (val) {
                clearTimeout(this._errorTimeout);
                this._errorTimeout = setTimeout(() => { this.paymentError = false; }, 10000);
            }
        },
        isMobile: {
            immediate: true,
            handler(newVal) {
                console.log('Mobile view:', newVal);
            }
        },
        'paymentInfo.payment_terms'() {
            this.couponInput = "";
            this.paymentInfo.couponId = null;
            this.couponApplied = false;
            this.paymentInfo.discount = 0;
        }
    },
    methods: {
        ...mapActions([
            'setCartVisibility',

            'clearCart',
            'removeFromCart'
        ]),

        async handlePageShow(event) {
            if (event.persisted) {
                this.submitted = false;
                await this.initStripe();
                if (this.$refs.stripePayment) {
                    this.$refs.stripePayment.resetElement();
                }
            }
        },

        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        async loadPlans() {
            try {
                const productId = this.getMainProduct?.id;
                if (!productId) return;
                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`, {
                    params: { isPromo: true, productId }
                });
                if (response.data.status === 'success' && Array.isArray(response.data.plans)) {
                    const plans = {};
                    response.data.plans.forEach((plan) => {
                        if (plan && plan.terms != null && plan.price != null) {
                            plans[Number(plan.terms)] = { id: plan.id, price: Number(plan.price) };
                        }
                    });
                    this.apiPlans = plans;
                }
            } catch (error) {
                console.error('Error loading plans:', error);
            }
        },
        getProductPricing() {
            const mainProduct = this.getMainProduct;
            const base = mainProduct.name === 'Semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
            // Merge live plan prices over the env pricing so missing terms keep the fallback
            const pricing = { monthly: { ...base.monthly }, terms: { ...base.terms } };
            if (this.apiPlans[1]) {
                pricing.monthly = { first: this.apiPlans[1].price, regular: this.apiPlans[1].price };
            }
            [3, 6, 12].forEach((term) => {
                if (this.apiPlans[term]) {
                    pricing.terms[term] = this.apiPlans[term].price;
                }
            });
            return pricing;
        },
        getFirstMonthPrice() {
            return this.getProductPricing().monthly.first;
        },
        getRegularMonthlyPrice() {
            return this.getProductPricing().monthly.regular;
        },
        getMonthlyDiscount() {
            const discount = this.getRegularMonthlyPrice() - this.getFirstMonthPrice() + parseInt(this.paymentInfo.discount || 0);
            return parseFloat(discount.toFixed(2));
        },
        getTotalPrice(term) {
            return parseFloat(this.getProductPricing().terms[term].toFixed(2));
        },
        getMonthlyPrice(term) {
            const monthlyPrice = this.getTotalPrice(term) / term;
            return parseFloat(monthlyPrice.toFixed(2));
        },
        getCurrentMainProductPrice() {
            let price;
            if (this.paymentInfo.payment_terms === 1) {
                price = this.getFirstMonthPrice();
            } else {
                price = this.getTotalPrice(this.paymentInfo.payment_terms);
            }
            return parseFloat(price.toFixed(2));
        },
        getCurrentPrice() {
            if (this.paymentInfo.payment_terms === 1) {
                // For monthly plans, show the FIRST MONTH discounted price
                return parseFloat(this.getFirstMonthPrice().toFixed(2));
            } else {
                // For multi-month plans, show the total plan price
                return parseFloat(this.getCurrentMainProductPrice().toFixed(2));
            }
        },
        getTotalOrderAmount() {
            let total = this.getCurrentMainProductPrice();

            // Add addon prices for current billing period
            this.getAddonProducts.forEach(addon => {
                const addonTotal = addon.price * addon.quantity;
                total += parseFloat(addonTotal.toFixed(2));
            });

            return parseFloat(total.toFixed(2));
        },
        getAddonTotalForPeriod() {
            const total = this.getAddonProducts.reduce((total, addon) => {
                const addonPrice = addon.price * addon.quantity;
                return total + parseFloat(addonPrice.toFixed(2));
            }, 0);
            return parseFloat(total.toFixed(2));
        },
        async removeItem(itemId) {
            try {
                this.removeFromCart(itemId);
                this.setCartVisibility(false);
            } catch (error) {
                console.log(error)
            }
        },

        showChatWindow() {
            this.$emit("showChatWindow");
        },

        async handleCouponSubmit() {
            this.errorMessage = null;
            if (!this.couponInput) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            this.paymentInfo.couponCode = this.couponInput;
            await this.validateCoupon();
        },
        async validateCoupon() {
            if (this.couponApplied) return;
            this.couponError = false;
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode,
                    payment_terms: this.paymentInfo.payment_terms
                });

                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    if(response.data.c_type===2){
                        // Calculate percentage-based discount
                        const planAmount = this.getTotalOrderAmount();
                        const discountPercentage = response.data.c_val;
                        this.paymentInfo.discount = parseFloat(((planAmount * discountPercentage) / 100).toFixed(2));
                    }else{
                        this.paymentInfo.discount = response.data.c_val;
                    }

                } else {
                    this.couponValid = false;
                    this.couponError = true;
                }
            } catch (error) {
                this.couponValid = false;
                this.couponError = true;
            }
        },
        async checkAuthAndInitialize() {
            if (!this.isLoggedin) {
                this.$axios.get(`${this.baseUrl}/api/get-cart/${this.$route.params.cart_id}`, {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    }).then(response => {
                        if (response.data.status === 'success') {
                            let cartItem = response.data.cartItem;
                            try {
                                let keyToDelete = "sema_offer";
                                if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                    this.$store.dispatch('addSemaOffer', cartItem[keyToDelete]);
                                    delete cartItem[keyToDelete];
                                }
                                keyToDelete = "tir_offer";
                                if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                    this.$store.dispatch('addTirOffer', cartItem[keyToDelete]);
                                    delete cartItem[keyToDelete];
                                }
                            } catch (error) {
                                console.log(error.message)
                            }

                            this.$store.dispatch("doLogin", response.data.userData);
                            this.$store.dispatch('addToCart', cartItem);
                            this.setCartVisibility(false);
                            window.location.reload();

                        } else {
                            this.initilizingCart = false;
                            this.message = response.data.message;
                            this.cartError = true;
                            console.error("Unexpected response:", response.data);
                        }
                    })
                    .catch(error => {
                        console.error("Error saving cart:", error);
                        this.initilizingCart = false;
                        this.message = `${error.message}. Please check the checkout link is correct.`
                        this.cartError = true;
                    });
            } else {
                // Pull live PROMO plan prices before showing the checkout so displayed prices
                // reflect the backend, not the stale env fallback.
                await this.loadPlans();
                this.initilizingCart = false;
                await this.initStripe();
                this.prefillFromUserData();
                // Report the cart once live pricing is in, so the default term's real
                // plan price is what gets sent. The logged-out branch above reloads the
                // page and lands here on the second pass, so this still fires once.
                this.fireAddToCart();
            }
        },

        async initStripe() {
            try {
                stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
            } catch (error) {
                console.error('Failed to initialize Stripe:', error);
            }
        },

        prefillFromUserData() {
            const shipping = this.$store.getters.shipping;
            if (shipping) {
                if (!this.customerInfo.addressLine1 && shipping.address_line_1) this.customerInfo.addressLine1 = shipping.address_line_1;
                if (!this.customerInfo.addressLine2 && shipping.address_line_2) this.customerInfo.addressLine2 = shipping.address_line_2;
                if (!this.customerInfo.city && shipping.city) this.customerInfo.city = shipping.city;
                if (!this.customerInfo.state && shipping.state) this.customerInfo.state = shipping.state;
                if (!this.customerInfo.zip && shipping.zip) this.customerInfo.zip = shipping.zip;
            }
        },

        openPaymentMethod(val) {
            if (val == this.payment_open) {
                this.payment_open = 0;
            } else {
                this.payment_open = val;
            }
        },
        changePaymentTerms(value) {
            this.paymentInfo.payment_terms = value;
            // Re-report the cart on every term change. Without this add_to_cart only
            // ever described the default term, so a 12-month cart looked like a 6-month one.
            this.fireAddToCart();
        },

        // event_value is the plan price for the selected term — what the shopper pays
        // for the plan itself, before any coupon or discount and without addons.
        fireAddToCart() {
            const term = Number(this.paymentInfo.payment_terms);
            // Nothing can be reported yet: the cart is still being built or the
            // pixel has not loaded. Leave lastTrackedTerm alone, so the fire that
            // happens once the cart lands is not mistaken for a duplicate.
            if (!window.tracking || !this.getMainProduct) return;
            if (term === this.lastTrackedTerm) return;

            try {
                window.tracking.event('add_to_cart', {
                    funnel_step: 16,
                    event_value: this.getCurrentMainProductPrice(),
                    currency: 'USD',
                    product_id: this.getMainProduct.id,
                    product_name: this.getMainProduct.name,
                    plan_id: this.getMainProduct.stripe_id,
                    quantity: 1,
                    form: "pre_qualify"
                });
                this.lastTrackedTerm = term;
            } catch (error) {
                console.log(error);
            }
        },

        handlePaymentError(message) {
            this.paymentError = true;
            this.errorMessage = message;
            this.submitted = false;
        },
        handlePaymentToken(pmToken) {
            this.paymentInfo.cardToken = pmToken;
            this.paymentInfo.paymentMethod = 'card';
            this.processPayment();
        },
        async handleExpressPayment(ev) {
            if (this.submitted) { ev.complete('fail'); return; } // a charge is already in flight
            try {
                this.submitted = true;
                this.correlationId = crypto.randomUUID();
                this.paymentError = false;
                this.paymentInfo.cardToken = ev.tokenId;
                this.paymentInfo.cardDetails = {
                    number: `XXXXXXXXXXXX${ev.card.last4}`,
                    expiration_month: ev.card.exp_month,
                    expiration_year: ev.card.exp_year,
                    cardBin: '',
                    cardBrand: ev.card.brand,
                    cardLast4: ev.card.last4,
                };
                this.paymentInfo.cardLast4 = ev.card.last4;
                this.paymentInfo.cardBrand = ev.card.brand;
                this.paymentInfo.paymentMethod = ev.methodName === 'apple-pay' ? 'apple_pay' : 'google_pay';
                if (ev.payerEmail && !this.paymentInfo.email) {
                    this.paymentInfo.email = ev.payerEmail;
                }
                await this.processPayment();
                ev.complete('success');
            } catch (error) {
                console.error('[Checkout] Express payment error:', error);
                ev.complete('fail');
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Payment failed. Please try again.';
                this.submitted = false;
            }
        },

        isPOBox(address) {
            const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
            const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
            return poBoxRegex.test(normalized);
        },
        getAddressData(address) {
            if (this.isPOBox(address.street)) {
                this.addressError = true;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
            } else {
                this.addressError = false;
                this.customerInfo.addressLine1 = address.street;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
                this.updateAddress();
            }
        },
        async updateAddress() {
            try {
                this.customerInfo.id = this.user.id;
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
            } catch (error) {
                console.error('Error updating address:', error);
                throw new Error('Failed to update address');
            }
        },
        validateAddress(address) {
            return address.addressLine1 &&
                address.city &&
                address.state &&
                address.zip;
        },
        blinkAddress() {
            this.addressBlink = true;
            setTimeout(() => { this.addressBlink = false; }, 1500);
        },
        async getStripeToken() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;
            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete shipping address.";
                this.blinkAddress();
                this.submitted = false;
                return false;
            }
            this.errorReason = false;

            if (this.$refs.stripePayment) {
                await this.$refs.stripePayment.confirmPayment();
            }
        },
        async sendRequest(paymentData) {
            // ===== COMMENTED OUT: Original endpoint =====
            // let response = await this.$axios.post(`${this.baseUrl}/api/checkout-newself`, paymentData)
            // ===== END COMMENTED OUT =====
            let response = await this.$axios.post(`${this.baseUrl}/api/checkout-stripe`, paymentData, {
                headers: { 'X-Correlation-Id': this.correlationId }
            })
            return response;
        },
        async payWithKlarna() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = 'Please enter a complete shipping address.';
                this.blinkAddress();
                this.submitted = false;
                return;
            }
            if (this.isPOBox(this.customerInfo.addressLine1)) {
                this.addressError = true;
                this.submitted = false;
                return;
            }

            try {
                const billingAddr = this.customerInfo;
                const shippingAddress = {
                    addressLine1: this.customerInfo.addressLine1,
                    addressLine2: this.customerInfo.addressLine2,
                    city: this.customerInfo.city,
                    state: this.customerInfo.state,
                    zip: this.customerInfo.zip,
                };

                const totalAmount = this.amountInCents;
                const discountAmount = Math.round((this.paymentInfo.discount || 0) * 100);
                const chargeAmount = totalAmount - discountAmount;

                const response = await this.$axios.post(`${this.baseUrl}/api/create-payment-intent`, {
                    id: this.user.id,
                    amount: chargeAmount,
                    payment_method_types: ['klarna'],
                    user_id: this.user.id,
                    planId: this.selectedPlanId,
                    payment_terms: this.paymentInfo.payment_terms,
                    couponId: this.paymentInfo.couponId,
                    discount: this.paymentInfo.discount,
                    firstName: this.user.first_name,
                    lastName: this.user.last_name,
                    email: this.user.email,
                    cartTotal: this.cartTotal,
                    shippingAddress,
                    billingAddress: {
                        addressLine1: billingAddr.addressLine1,
                        addressLine2: billingAddr.addressLine2,
                        city: billingAddr.city,
                        state: billingAddr.state,
                        zip: billingAddr.zip,
                    },
                    cartItems: this.orderCartItems,
                    // Stamped onto the PaymentIntent metadata, which fulfillment reads.
                    offer: this.nadOfferSlug || this.offer,
                    mainProductTotal: this.getCurrentMainProductPrice(),
                    addonTotal: this.getAddonTotalForPeriod(),
                    totalOrderAmount: this.displayTotal,
                    medication: this.paymentInfo.medication,
                    drug_mode: this.paymentInfo.drug_mode || '',
                }, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });

                const { clientSecret } = response.data;
                const currentUrl = window.location.origin;
                const cartId = this.$route.params.cart_id;
                // The offer params ride along so "Try again" lands back on the same offer.
                const offerParams = new URLSearchParams(offerQuery(this.$route.query)).toString();
                const returnUrl = `${currentUrl}/weight-loss-payment/${cartId}/klarna-return${offerParams ? `?${offerParams}` : ''}`;

                // Snapshot the cart BEFORE redirecting to Klarna. KlarnaReturn.vue is a
                // fresh page load after the redirect and can't see this component's cart, so it
                // reads this back to send cartItems on /api/confirm-klarna-payment
                // ([{ id: productObjectId, quantity, price }]). Keyed to this payment intent so a
                // stale snapshot never attaches to another checkout that shares KlarnaReturn.vue.
                try {
                    const snapshotItems = [{
                        id: this.getcartItems?.id,
                        quantity: 1,
                        price: Number((chargeAmount / 100).toFixed(2)),
                    }];
                    // The offer's free NAD+ line at $0, so the lines still sum to the charge.
                    if (this.offerNadLine) {
                        snapshotItems.push({ id: this.offerNadLine.id, quantity: 1, price: 0 });
                    }
                    sessionStorage.setItem('pending_klarna_cart', JSON.stringify({
                        payment_intent_id: clientSecret.split('_secret')[0],
                        items: snapshotItems,
                    }));
                } catch (e) { /* sessionStorage unavailable — confirm falls back to paymentIntentId only */ }

                // Same reason the cart is snapshotted: this page never runs again after
                // the redirect, so it can't fire its own `purchase`. KlarnaReturn.vue
                // fires this once the server confirms the payment.
                const klarnaMainProduct = this.cartItems.find(item => !item.is_addon);
                stashKlarnaPurchase(clientSecret.split('_secret')[0], {
                    funnel_step: 17,
                    event_value: Number((chargeAmount / 100).toFixed(2)),
                    product_id: klarnaMainProduct?.id,
                    product_name: klarnaMainProduct?.name,
                    plan_id: klarnaMainProduct?.stripe_id,
                    quantity: 1,
                    coupon: this.paymentInfo.couponCode || undefined,
                    form: "pre_qualify"
                });

                // Klarna leaves the site, so KlarnaReturn.vue makes the offer instead.
                // Hand it the charge context before the redirect takes this page away.
                this.stashFastTrackOffer(clientSecret.split('_secret')[0], {
                    userId: this.user.id,
                    paymentMethod: 'klarna',
                    paymentTerms: this.paymentInfo.payment_terms,
                    firstName: this.user.first_name,
                    lastName: this.user.last_name,
                    email: this.user.email,
                    shippingAddress,
                    billingAddress: billingAddr,
                    trackingSessionId: window.trackingSessionId || null,
                    ipAddress: this.ip_address
                });

                const { error } = await stripe.confirmKlarnaPayment(clientSecret, {
                    payment_method: {
                        billing_details: {
                            name: `${this.user.first_name} ${this.user.last_name}`,
                            email: this.user.email,
                            address: {
                                line1: billingAddr.addressLine1,
                                line2: billingAddr.addressLine2 || '',
                                city: billingAddr.city,
                                state: billingAddr.state,
                                postal_code: billingAddr.zip,
                                country: 'US',
                            },
                        },
                    },
                    return_url: returnUrl,
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Klarna payment failed. Please try again.';
                    this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Failed to initiate Klarna payment. Please try again.';
                this.submitted = false;
            }
        },
        async processPayment() {
            try {
                this.submitted = true;
                this.paymentError = false;
                this.paymentInfo.user_id = this.user.id;
                this.paymentInfo.id = this.user.id;
                this.paymentInfo.cartItems = this.orderCartItems;
                this.paymentInfo.planId = this.selectedPlanId;

                let sessionId = "";
                try {
                    sessionId = await window.tracking.assertSession();
                } catch(error) {
                    if (window.trackingSessionId) {
                        sessionId = window.trackingSessionId;
                    }
                }

                let paymentData = {
                    ...this.paymentInfo,
                    amount: this.amountInCents,
                    cartTotal: this.cartTotal,
                    cartTotalNoDiscount: this.cartTotalNoDiscount,
                    offer: this.nadOfferSlug || this.offer,
                    billingAddress: this.customerInfo,
                    shippingAddress: this.customerInfo,
                    mainProductTotal: this.getCurrentMainProductPrice(),
                    addonTotal: this.getAddonTotalForPeriod(),
                    totalOrderAmount: this.getTotalOrderAmount(),
                    user_agent: window.navigator.userAgent || 'unknown',
                    ip_address: this.ip_address || 'unknown',
                    tracking_session_id: sessionId
                };

                const response = await this.sendRequest(paymentData);
                let amountCharged = ((paymentData.amount / 100) - paymentData.discount)

                if (response.data.status === 'success') {
                    // Save purchased products to localStorage
                    const purchasedItems = this.cartItems.map(item => ({
                        name: item.name,
                        price: amountCharged.toFixed(2)
                    }));
                    localStorage.setItem('productsPurchased', JSON.stringify(purchasedItems));

                    await this.$store.dispatch('setPrescriptionPreauths', response.data.prescriptionPreauths);
                    await this.updateAddress();
                    let transactionIdentifier;
                    try {
                        if (response.data.transaction_id) {
                            transactionIdentifier = response.data.transaction_id;
                        } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                            transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                        } else {
                            transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                        }
                    } catch (e) {
                        console.log(e)
                        transactionIdentifier = `${Date.now()}`;
                    }

                    // Fire purchase event after payment confirmed
                    try {
                        if (window.tracking) {
                            const mainProduct = this.cartItems.find(item => !item.is_addon);
                            window.tracking.event('purchase', {
                                funnel_step: 17,
                                event_value: amountCharged,
                                currency: 'USD',
                                transaction_id: transactionIdentifier,
                                order_id: response.data.orderId,
                                event_id: crypto.randomUUID(),
                                product_id: mainProduct?.id,
                                product_name: mainProduct?.name,
                                plan_id: mainProduct?.stripe_id,
                                quantity: 1,
                                coupon: this.paymentInfo.couponCode || undefined,
                                form: "pre_qualify"
                            });
                        }
                    } catch(error) {
                        console.log(error)
                    }

                    // Offer priority review on top of the confirmed order, then leave.
                    // With no add-on to offer this hands straight through to pushToRoute.
                    this.offerFastTrackThen({
                        userId: this.user.id,
                        paymentMethod: this.paymentInfo.paymentMethod || 'card',
                        paymentTerms: this.paymentInfo.payment_terms,
                        firstName: this.user.first_name,
                        lastName: this.user.last_name,
                        email: this.user.email,
                        shippingAddress: this.customerInfo,
                        billingAddress: this.customerInfo,
                        trackingSessionId: sessionId,
                        ipAddress: this.ip_address
                    }, () => this.leaveForUpsell(amountCharged, transactionIdentifier));
                } else {
                    this.errorMessage = response.data.message || "Payment failed";
                    this.submitted = false;
                    this.paymentError = true;
                     this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || "";
                this.submitted = false;
            }
        },
        // The cart is emptied HERE, on the way out, and never while this page is
        // still on screen. This page renders off the cart (getcartItems.name,
        // getImage, getMainProduct.name), and getMainProduct is undefined once the
        // cart is empty — so clearing mid-page throws inside render, Vue aborts the
        // patch, and the priority-review modal that was just switched on never
        // mounts. The mixin's 4s watchdog then gives up and redirects without ever
        // asking the patient.
        async leaveForUpsell(amountCharged, transaction_id) {
            try {
                await this.clearCart();
            } catch (error) {
                // The order is already paid. A failed cart clear must never cost
                // the patient their receipt.
                console.error('[checkout] clearCart failed on exit:', error);
            }
            this.pushToRoute(amountCharged, transaction_id);
        },

        pushToRoute(amountCharged, transaction_id) {
            try {
                const query = {};
                if (this.paymentInfo.payment_terms !== null) {
                    query.terms = String(this.paymentInfo.payment_terms);
                }
                query.amount = amountCharged;
                query.trans_id = transaction_id;
                query.payment_terms = '1';
                if (this.paymentInfo.paymentMethod) {
                    query.pm = this.paymentInfo.paymentMethod;
                }
                this.$router.push({
                    name: 'upSellPage',
                    query
                });
            } catch (error) {
                console.log(error);
                this.$router.push({
                    name: 'upSellPage',
                    query: { payment_terms: '1' }
                });
            }
        },
        getSavingsText(value) {
            const firstMonth = this.getFirstMonthPrice();
            const regularMonthly = this.getRegularMonthlyPrice();
            const monthlyPlanTotal = firstMonth + (regularMonthly * (value - 1));
            const prepaidTotal = this.getTotalPrice(value);
            const savings = monthlyPlanTotal - prepaidTotal;
            return `${parseFloat(savings.toFixed(2))} Total Savings`;
        },
        formatPrice(price) {
            return parseFloat(parseFloat(price).toFixed(2));
        },
        formatCurrency(price) {
            return `${this.formatPrice(price)}`;
        }
    },

    computed: {
        // EXISTING: Vuex getters mapping
        ...mapGetters([
            'user',
            'cartItems',
            'cartTotal',
            'cartDiscount',
            'cartTotalNoDiscount'
        ]),
        getMainProduct() {
            console.log(this.cartItems)
            return this.cartItems.find(item => item.is_addon === false) || this.cartItems[0];
        },
        getAddonProducts() {
            return this.cartItems.filter(item => item.is_addon === true);
        },
        // What the free NAD+ offer (freeNadLifeOffer mixin) checks the order against.
        offerGlpProductId() {
            return this.getMainProduct ? this.getMainProduct.id : null;
        },
        offerGlpTerms() {
            return this.paymentInfo.payment_terms;
        },
        // What the Apple/Google Pay sheet shows. Display only: the express element is
        // created with paymentMethodCreation:'manual', so it tokenizes and never charges.
        // amountInCents is GROSS on this page -- the backend applies the coupon -- so the
        // sheet has to net it here to match the Total the customer is looking at.
        walletSheetAmountInCents() {
            const discountCents = Math.round((this.paymentInfo.discount || 0) * 100);
            return Math.max(0, this.amountInCents - discountCents);
        },
        // What the customer sees as their total.
        displayTotal() {
            return this.getTotalOrderAmount();
        },
        getFirstMonthDollars() {
            return Math.floor(this.getFirstMonthPrice());
        },
        getFirstMonthCents() {
            const price = this.getFirstMonthPrice();
            const cents = Math.round((price - Math.floor(price)) * 100);
            return cents.toString().padStart(2, '0'); // Ensures 2-digit format like "97"
        },
        getQuarterlyDollars() {
            return Math.floor(this.getMonthlyPrice(3));
        },
        getQuarterlyCents() {
            const price = this.getMonthlyPrice(3);
            const cents = Math.round((price - Math.floor(price)) * 100);
            return cents.toString().padStart(2, '0');
        },
        getSixMonthDollars() {
            return Math.floor(this.getMonthlyPrice(6));
        },
        getSixMonthCents() {
            const price = this.getMonthlyPrice(6);
            const cents = Math.round((price - Math.floor(price)) * 100);
            return cents.toString().padStart(2, '0');
        },
        getAnnualDollars() {
            return Math.floor(this.getMonthlyPrice(12));
        },
        getAnnualCents() {
            const price = this.getMonthlyPrice(12);
            const cents = Math.round((price - Math.floor(price)) * 100);
            return cents.toString().padStart(2, '0');
        },
        getOrderSummaryPrice() {
            if (this.paymentInfo.payment_terms === 1) {
                // For monthly plans, show the discounted first month price
                return this.getFirstMonthPrice().toFixed(2);
            } else {
                // For multi-month plans, show the total plan price
                return this.getCurrentMainProductPrice().toFixed(2);
            }
        },
        getContinuationPrice() {
            return this.getRegularMonthlyPrice().toFixed(2);
        },
        isMonthlyPlan() {
            return this.paymentInfo.payment_terms === 1;
        },
        getMultiMonthTotal() {
            if (this.paymentInfo.payment_terms > 1) {
                return this.getTotalPrice(this.paymentInfo.payment_terms).toFixed(2);
            }
            return null;
        },
        getPlanPoints() {
            if (this.paymentInfo.payment_terms >= 3) {
                const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (this.paymentInfo.payment_terms - 1));
                const prepaidTotal = this.getTotalPrice(this.paymentInfo.payment_terms);
                const savings = monthlyPlanTotal - prepaidTotal;
                const savingsPercent = ((savings / monthlyPlanTotal) * 100).toFixed(0);

                return [{
                        "header": `${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month savings!`,
                        "sub_header": `You will save ${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month paying for ${this.paymentInfo.payment_terms} months up front (${savings.toFixed(0)} Total Savings) vs. our monthly installment plan.`
                    },
                    {
                        "header": `Save up to ${savingsPercent}%`,
                        "sub_header": `You will save big by paying for our ${this.paymentInfo.payment_terms} month program up front.`
                    }
                ];
            }
            return [{
                    "header": `${this.getFirstMonthPrice() - this.paymentInfo.discount} for the First Month`,
                    "sub_header": "This amount applies only to the first month, providing an upfront discount to new customers."
                },
                {
                    "header": `${this.getRegularMonthlyPrice()} per month thereafter`,
                    "sub_header": `After the first month, the customer will be charged the regular price of ${this.getRegularMonthlyPrice()} monthly.`
                },
                {
                    "header": "3 Month Supply Program",
                    "sub_header": "You'll receive a 3-month supply of medication, billed monthly. If you cancel before completing the full term, an early termination fee of $279.97 will apply."
                }
            ];
        },
        getOfferName() {
            let offer = this.$store.getters.offerTir;
            if (this.getMainProduct.name === 'Semaglutide') {
                offer = this.$store.getters.offerSema;
            }
            return offer;
        },
        selectedPlanId() {
            // Plan ObjectId for the selected term (backend charges the plan price off this).
            // Falls back to the store offer when the live plan for this term didn't load.
            const plan = this.apiPlans[this.paymentInfo.payment_terms];
            return plan ? plan.id : this.getOfferName;
        },
        getSupplyDuration() {
            if (this.paymentInfo.payment_terms === 1 || this.paymentInfo.payment_terms === 3) {
                return "3 Month Supply"
            } else if (this.paymentInfo.payment_terms === 6) {
                return "3 month supply now, 3 more in 90 days."
            } else {
                return "3 Vials Every 90 Days for a Year."
            }
        },
        getImage() {
            return this.getMainProduct.image;
        },
        getcartItems() {
            return this.getMainProduct;
        },
        isMobile() {
            return detectMobile();
        },
        isLoggedin() {
            return this.$store.getters.isAuthenticated;
        },
        amountInCents() {
            return Math.round(this.getTotalOrderAmount() * 100);
        },
        finalTotal() {
            if (this.couponApplied) {
                return this.cartTotalNoDiscount - this.paymentInfo.discount;
            }
            return this.cartTotal;
        },
        getDiscount() {
            if (this.couponApplied) {
                return this.paymentInfo.discount;
            }
            return this.cartDiscount;
        }
    }
}
</script>

<style scoped>
/* The free NAD+ pictures (the injection vial, the nasal bottle) are cut-outs with no
   margin. The Tirzepatide picture beside them is a square whose vial fills the middle
   66% of its height, so pad 17% a side to draw them the same size (as
   checkoutCallCenter.vue does). */
.offer-image {
    width: 100%;
    height: 100%;
    padding: 17%;
    box-sizing: border-box;
    object-fit: contain;
}

/* What the free line promises, under its name. Size and spacing from the newforms
   checkout that prints the same sentence; colour is this page's muted grey. */
.free-nad-note {
    margin-top: 6px;
    font-size: 11px;
    line-height: 1.45;
    color: #6b7280;
    text-wrap: pretty;
}

/* Plan badges (Popular / Recommended) */
.plan-badge {
    position: absolute;
    top: -13px;
    left: 18px;
    z-index: 2;
    background-color: #d7fff0;
    color: #000;
    font-family: var(--satoshi, 'Satoshi', sans-serif);
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    padding: 6px 11px;
    border-radius: 999px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}


/* Plan card spacing/padding — bigger, more uniform */
.plan-radio {
    margin-bottom: 22px;
    padding: 22px 30px;
}

.plan-radio:last-of-type {
    margin-bottom: 0;
}

.checkout-popup-div {
    position: fixed;
    inset: 0;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.15);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.popup-box {
    background: white;
    padding: 20px;
    border-radius: 8px;
    min-width: 300px;
    max-width: 500px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

    position: relative;
    /* makes sure absolute children position inside */
    margin: 0 !important;
    /* override any external margins */
}

.checkout-button-3-checkout {
    background-color: #00c042;
    font-family: var(--satoshi-switch);
    font-weight: 700;
    color: #fff;
    text-align: center;
    border-radius: 9px;
    border: 1px solid #000;
    width: 100%;
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 20px;
    line-height: 26px;
    padding-top: 0px;
    padding-bottom: 0px;
}

/* Express Checkout */
.error-popup {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #fee2e2;
    border: 1px solid #ef4444;
    color: #991b1b;
    padding: 12px 24px;
    border-radius: 8px;
    z-index: 2147483647;
    max-width: 90%;
    text-align: center;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.error-popup-close {
    background: none;
    border: none;
    color: #991b1b;
    font-size: 20px;
    cursor: pointer;
    padding: 0 2px;
    line-height: 1;
    flex-shrink: 0;
}

.express-checkout-section {
    margin-bottom: 16px;
}

.express-checkout-box {
    background: white;
    border: 1px solid #d8dbe0;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* NOTE: Uses .pe-divider instead of .divider — webflow CSS defines .divider { width: 1px } which would turn this vertical. */
.pe-divider {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
    margin: 12px 0;
    border: none;
    background: transparent;
}

.pe-divider-line {
    flex: 1;
    height: 1px;
    min-width: 0;
    background: #d8dbe0;
}

.pe-divider span {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
}

.pe-label-7x {
    font-weight: 350 !important;
    color: #4a4a57 !important;
    font-size: 0.9rem !important;
    line-height: 1.15 !important;
    margin-bottom: 4px !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
}
@media screen and (max-width: 991px) {
    .pe-label-7x {
        font-size: 16px !important;
        color: #000 !important;
    }
}

.address-section {
    margin-bottom: 20px;
}

.address-highlight :deep(input) {
    animation: blink-red 0.5s ease 3;
}
@keyframes blink-red {
    0%, 100% { border-color: inherit; }
    50% { border-color: #dc2626; box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.3); }
}

/* Klarna Button */
.klarna-btn {
    width: 100%;
    background: #ffb3c7;
    color: #0b0b0b;
    border: none;
    border-radius: 4px;
    padding: 12px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    font-family: inherit;
    height: 48px;
}

.klarna-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 179, 199, 0.5);
}

.klarna-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.klarna-btn-text {
    font-size: 16px;
    font-weight: 600;
}

.klarna-logo {
    height: 18px;
    width: auto;
}

.hide-desk{
    display: none;
}
@media screen and (max-width: 1215px) {
    .hide-desk{
        display: block;
    }
}
@media screen and (max-width: 479px) {
    .hide-desk{
        display: block;
    }
    .text-block-1562
    {
        font-size: 12.5px !important;
        font-weight: normal !important;
    }
    .dropdown-sum-toggle {
        padding-bottom: 0px;
    }
    .hidemobile{
        display: none;
    }

    /* Express checkout on mobile */
    .express-checkout-box {
        padding: 16px;
    }

    .klarna-btn {
        flex-direction: column;
        padding: 4px 6px;
        gap: 2px;
        height: 48px;
        margin-top: 0;
    }

    .klarna-btn-text {
        font-size: 11px;
        white-space: nowrap;
    }

    .klarna-logo {
        height: 16px;
    }

    .klarna-btn:only-child,
    .express-checkout-box.single-option .klarna-btn {
        grid-column: 1 / -1;
    }

    .error-popup {
        min-width: 90%;
    }
}


.image-490 {
    display: inline-block !important;
    vertical-align: middle;
    margin-right: 4px;
    max-width: 16px;
    max-height: 16px;
}

.text-block-822 {
    display: flex !important;
    align-items: center;
    justify-content: flex-end;
    white-space: nowrap;
}
</style>
